module.exports = __webpack_public_path__ + "img/ic_32_workout_medium-active.dbc038c0.svg";